export default __webpack_public_path__ + "static/media/dc.f930c59d.png";